import { IApiToken } from '../types/IApiToken';
import { Request } from './Request';

export class CreateApiTokenRequest extends Request<Object, any> {
  constructor(clientName: string) {
    super('createApiToken', {'apiToken' : <IApiToken>{'clientName' : clientName}});
  }
}
